import { defaultTheme, Icons } from '@agro-club/agroclub-shared'
import styled from 'styled-components'

export const ImagesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const FileWrapper = styled.div`
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  border: solid 1px ${defaultTheme.color.secondary100};
  &:hover {
    border: solid 1px ${defaultTheme.color.primary200};
  }
`
export const FilePlaceholder = styled.div`
  border-radius: 8px;
  height: 100px;
  width: 100px;
  display: flex;
  flex-direction: column;
  padding: 4px;
  align-items: center;
  justify-content: center;
  word-break: break-all;
`

export const AddBtn = styled(FileWrapper)`
  border: none;
  background-color: ${defaultTheme.color.accentApprove16a};
  &:hover {
    background-color: ${defaultTheme.color.accentApprove24a};
    border: none;
  }
`

export const IconContainer = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  border-radius: 4px;
  background-color: white;
  overflow: hidden;
  width: 20px;
  height: 20px;

  svg {
    width: 20px;
    height: 20px;

    path {
      fill: ${defaultTheme.color.primary600};
    }
  }
`

export const NumberContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -20px 0 0 -10px;
`

export const AddFileIcon = styled(Icons.IconAdd)`
  width: 40px;
  height: 40px;

  path {
    fill: ${defaultTheme.color.accentApprove600};
  }
`

export const PreviewContainer = styled.div`
  white-space: pre-wrap;
  margin-top: 4px;
`
